import { defineComponent } from "vue";
import common from "../core/core";

import { mainModelService } from "@/services/main.model.service";
import { debounce, Subject, timer } from "rxjs";

export default defineComponent({
  data() {
    return {
      searchRes: [] as any[],
      searchQuery: "",
      searchSubject: new Subject<void>(),
      loadingSearch: false,
      isSearchRequest: null,
      searchRequestStatus: true,
    };
  },
  mounted() {
    this.searchSubject.pipe(debounce(() => timer(300))).subscribe(() => {
      this.searchRequest();
    });
  },
  watch: {
    searchQuery(value) {
      this.searchSubject.next();
    },
  },
  methods: {
    clearSearch() {
      this.searchQuery = "";
      this.searchRes = [];
    },
    searchRequest() {
      this.loadingSearch = true;
      this.isSearchRequest?.abort();

      // Ugly, but works fine, consider for refactoring
      const model = document.querySelector("#autosuggest-input")?.getAttribute("attr-model");

      this.isSearchRequest = mainModelService.searchRequestCall(
        model,
        {
          searchQuery: this.searchQuery,
          postId: window.postId,
        },
        (data: any) => {
          if (model === "support") {
            const faqSuggests = this.supportFAQSearch();
            if (faqSuggests.length) {
              data.data = [...data.data, ...faqSuggests];
            }
          }
          this.searchRes = data.data;
          this.searchRequestStatus = data.status;
          this.loadingSearch = false;
        }
      );
    },
    supportFAQSearch() {
      const list = [];
      const containers = document.querySelectorAll(".accordion-tab-content .faq-block");
      for (let i = 0; i < containers.length; i++) {
        const container = containers[i];
        if (container) {
          const categories = container.querySelectorAll(".accordion-tab-content__header");
          const questions = container.querySelectorAll(".accordion-tab-sub-pointer");
          const answers = container.querySelectorAll(".accordion-tab-text");
          if (categories) {
            for (let index = 0; index < categories.length; index++) {
              if (categories[index]?.textContent?.toLowerCase()?.includes(this.searchQuery?.toLowerCase())) {
                list.push({
                  isFAQ: true,
                  title: categories[index].textContent,
                  suggestDescription: "",
                  link: "#faq_category_" + index,
                  type: "category",
                  index,
                  el: categories[index],
                  tabIndex: i,
                });
              }
            }
          }
          if (questions) {
            for (let index = 0; index < questions.length; index++) {
              if (questions[index]?.textContent?.toLowerCase()?.includes(this.searchQuery?.toLowerCase())) {
                const firstAnswer = questions[index].nextSibling;
                list.push({
                  isFAQ: true,
                  title: questions[index].textContent,
                  suggestDescription: firstAnswer.textContent || "",
                  link: "#faq_question_" + index,
                  type: "question",
                  index,
                  el: questions[index],
                  categoryIndex: Number(questions[index].getAttribute("data-category-index")) || 0,
                  questionIndex: Number(questions[index].getAttribute("data-question-index")) || 0,
                  tabIndex: i,
                });
              }
            }
          }
          if (answers) {
            for (let index = 0; index < answers.length; index++) {
              if (answers[index]?.textContent?.toLowerCase()?.includes(this.searchQuery?.toLowerCase())) {
                list.push({
                  isFAQ: true,
                  title: answers[index].textContent,
                  suggestDescription: "",
                  link: "#faq_answer_" + index,
                  type: "answer",
                  index,
                  el: answers[index],
                  categoryIndex: Number(answers[index].getAttribute("data-category-index")) || 0,
                  questionIndex: Number(answers[index].getAttribute("data-question-index")) || 0,
                  tabIndex: i,
                });
              }
            }
          }
        }
      }
      return list;
    },
  },
  mixins: [common],
});
